// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".prices.top{display:inline-block;line-height:12px;margin-right:20px}.prices.top .originalPrice{font-size:var(--font-size-14);text-decoration:line-through}.prices.top .newPrice{font-size:1.4em;line-height:28px;color:var(--accent-color)}.prices.top .regularPrice{color:var(--coral);font-size:1.4em}.prices.desktop{display:inline-block;line-height:40px;text-align:right;margin-right:20px}.prices.desktop .originalPrice{margin-right:14px;font-size:var(--font-size-16);text-decoration:line-through;color:var(--grey-medium)}.prices.desktop .newPrice{float:right;font-size:1.5em}.prices.desktop .regularPrice{font-size:1.5em;color:var(--coral)}\n", ""]);
// Exports
exports.locals = {
	"extraSmallBreakpoint": "320px",
	"smallBreakpoint": "425px",
	"mobileBreakpoint": "768px",
	"tabletBreakpoint": "970px",
	"desktopBreakpoint": "1200px",
	"largeBreakpoint": "1400px",
	"extraLargeBreakpoint": "1600px"
};
module.exports = exports;
